export { MailCalendar as default } from './MailCalendar';
